function NoMatch() {

    return (
        <div>
            Error 404
        </div>
    )
    
}

export default NoMatch;